import { ASSET_FAMILY_FACTS, isAssetFamily } from "@digital-twins/shared-types";
import type { TestedAssetType } from "@digital-twins/shared-types";

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === "object" && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}

/**
 * What the review step's "Testing" column says: the study's tested assets
 * counted per family, in the block's order, named with the family registry's
 * nouns ("3 ads", "2 pack designs, 1 ad"). Null when the study tests none.
 *
 * Reads the compiled survey's `testedAssets`, which is the draft's typed block
 * as it launches, and the same survey the step sizes and bills.
 */
export function testedMaterialsSummary(surveyJson: unknown): string | null {
  const assets = asRecord(asRecord(surveyJson).testedAssets).assets;
  const counts = new Map<TestedAssetType, number>();
  for (const asset of Array.isArray(assets) ? assets : []) {
    const family = asRecord(asset).type;
    if (isAssetFamily(family)) counts.set(family, (counts.get(family) ?? 0) + 1);
  }
  if (counts.size === 0) return null;
  return [...counts]
    .map(([family, count]) => {
      const { singular, plural } = ASSET_FAMILY_FACTS[family].nouns;
      return `${count} ${count === 1 ? singular : plural}`;
    })
    .join(", ");
}
